import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createQcsThunks, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import { mileageTrackerVehicleApi } from '../mileage-tracker/mileageTrackerApi';
import {
  MILEAGE_TRACKER_VEHICLE_REDUCER_KEY,
  type MileageTrackerVehicleState,
  type MileageTrackerVehicleType,
} from './mileageTrackerVehicleTypes';

const initialState: MileageTrackerVehicleState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/mileageTrackerVehicle/mileageTrackerVehicleSlice.ts');

const entityAdapter = createResourceEntityAdapter<MileageTrackerVehicleType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: MILEAGE_TRACKER_VEHICLE_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(mileageTrackerVehicleActions.fetch());
      },
      api: mileageTrackerVehicleApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const mileageTrackerVehicleActions = slice.actions;
export const mileageTrackerVehicleSelectors = slice.selectors;
export { slice as mileageTrackerVehicleSlice };

export default slice.reducer;
